import { render, staticRenderFns } from "./camera2.vue?vue&type=template&id=58469248&scoped=true"
import script from "./camera2.vue?vue&type=script&lang=js"
export * from "./camera2.vue?vue&type=script&lang=js"
import style0 from "./camera2.vue?vue&type=style&index=0&id=58469248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58469248",
  null
  
)

export default component.exports